import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'

import { RichEditorStore } from './interface'

/**
 * 文本块类型
 */
export const BLOCK_TYPE_LIST = [
  {
    tag: 'p',
    label: '正文',
    value: 'paragraph'
  },
  {
    tag: 'h1',
    label: '标题一',
    value: 'h1'
  },
  {
    tag: 'h2',
    label: '标题二',
    value: 'h2'
  },
  {
    tag: 'h3',
    label: '标题三',
    value: 'h3'
  },
  {
    tag: 'h4',
    label: '标题四',
    value: 'h4'
  }
]

/**
 * 快捷键映射
 */
export const BLOCK_TYPE_SHORTCUT_MAP = {
  paragraph: SHORTCUTS.NORMAL,
  h1: SHORTCUTS.HEADING1,
  h2: SHORTCUTS.HEADING2,
  h3: SHORTCUTS.HEADING3,
  h4: SHORTCUTS.HEADING4
}

/**
 * 字体，只列出常用的合同字体
 * 备注：不要使用宋体，中英文混排时中文、英文、符号会错位
 */
export const FONT_FAMILY_LIST: RichEditorStore['fontFamilyList'] = [
  {
    label: '仿宋',
    value: 'FangSong,STFangsong'
  },
  {
    label: '楷体',
    value: 'KaiTi,STKaiti'
  },
  {
    label: '黑体',
    value: 'SimHei,STHeiti'
  },
  {
    label: '微软雅黑',
    value: 'Microsoft YaHei'
  },
  {
    label: 'Times New Roman',
    value: 'Times New Roman'
  },
  {
    label: 'Courier',
    value: 'Courier'
  },
  {
    label: 'Helvetica',
    value: 'Helvetica'
  }
]

/**
 * 字号，对齐 word
 */
export const FONT_SIZE_LIST: RichEditorStore['fontSizeList'] = [
  {
    label: '初号',
    value: 56
  },
  {
    label: '小初',
    value: 48
  },
  {
    label: '一号',
    value: 34
  },
  {
    label: '小一',
    value: 32
  },
  {
    label: '二号',
    value: 28
  },
  {
    label: '小二',
    value: 24
  },
  {
    label: '三号',
    value: 22
  },
  {
    label: '小三',
    value: 20
  },
  {
    label: '四号',
    value: 18
  },
  {
    label: '小四',
    value: 16
  },
  {
    label: '五号',
    value: 14
  },
  {
    label: '小五',
    value: 12
  },
  {
    label: '六号',
    value: 10
  },
  {
    label: '小六',
    value: 9
  }
]

/**
 * 行高，假设以 14px 的字号为基数换算
 */
export const LINE_HEIGHT_LIST: RichEditorStore['lineHeightList'] = [
  {
    label: '默认',
    value: 1.571428
  },
  {
    label: '1',
    value: 1
  },
  {
    label: '1.25',
    value: 1.2587
  },
  {
    label: '1.5',
    value: 1.5
  },
  {
    label: '1.75',
    value: 1.75
  },
  {
    label: '2',
    value: 2
  },
  {
    label: '2.5',
    value: 2.5
  },
  {
    label: '3',
    value: 3
  }
]
